import { CZ_DATE_FORMAT, DATE_FORMAT, GR_DATE_FORMAT, HU_DATE_FORMAT, ID_DATE_FORMAT, JP_DATE_FORMAT, localeMap, ZH_DATE_FORMAT } from 'app/modules/Constants';
import Helper from 'app/modules/Helper';
import { format, Locale } from "date-fns";

export function formattedDateString({ date, lng }: { date: Date; lng: string }) {
	const langCode = Helper.getLanguageCode(lng);
	let dateDisplayFormat = DATE_FORMAT;
	if (langCode === 'jp') {
		dateDisplayFormat = JP_DATE_FORMAT;
	} else if (langCode === 'id') {
		dateDisplayFormat = ID_DATE_FORMAT;
	} else if (langCode === 'zh') {
		dateDisplayFormat = ZH_DATE_FORMAT;
	} else if (langCode === 'gr') {
		dateDisplayFormat = GR_DATE_FORMAT;
	} else if (langCode === 'cz') {
		dateDisplayFormat = CZ_DATE_FORMAT;
	} else if (langCode === 'hu') {
		dateDisplayFormat = HU_DATE_FORMAT;
	}
	const isKorean = langCode === 'ko';
	const isSwedish = langCode === 'sv';
	const isRussian = langCode === 'ru';
	const isCzech = langCode === 'cz';
	const isHungarian = langCode === 'hu';
	let formattedDate = format(date, dateDisplayFormat, { locale: localeMap[lng] });
	if (isRussian) {
		formattedDate = formattedDate.slice(0, 2) + formattedDate.slice(3);
	}
	if (isKorean) {
		formattedDate += '일';
	}

	formattedDate = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);

	let renderText: string | React.ReactNode = (
		<span style={{ textTransform: 'capitalize' }}>{formattedDate}</span>
	);

	if (isSwedish) {
		// Capitalize day, lowercase month
		renderText = formattedDate.replace(
			/(\D+),\s(\D+)/,
			(_, day, month) => `${day.charAt(0).toUpperCase() + day.slice(1)}, ${month.toLowerCase()}`
		);
	}

	if (isCzech || isHungarian) {
		// Czech and Hungarian month abbreviations must stay lowercase
		// (Úte, 23. čvn / Sze, jún. 24.); the capitalize span above
		// would render the month as "Čvn" / "Jún."
		renderText = formattedDate;
	}

	return { ariaLabelString: formattedDate, renderText };
}
/**
 * Date format for the compare rows (date without weekday).
 * Indonesian and Czech put the day before the month; Czech and Hungarian add a period after the day.
 * @param langCode - Language code resolved via Helper.getLanguageCode
 * @returns date-fns format string
 */
export function getCompareDateFormat(langCode: string): string {
	if (langCode === 'id') {
		return 'd MMM';
	}
	if (langCode === 'cz') {
		return 'd. MMM';
	}
	if (langCode === 'hu') {
		return 'MMM d.';
	}
	return 'MMM d';
}
/**
 * Formats a date string with proper weekday abbreviations for different languages
 * For Russian, uses 2-letter weekday abbreviations instead of the default 3-letter ones
 * @param date - Date
 * @param locale - Locale object
 * @returns Formatted date string with weekday, day and month
 */
export function getFormattedWeekDate(date: Date, locale?: Locale) {
	if (locale?.code === 'ru') {
		// Russian 2-letter weekday abbreviations
		const russianWeekdays = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
		const weekday = russianWeekdays[date.getDay()]
		return weekday
	} else {
		// For other languages, use the standard format
		return format(date, 'EEE', { locale })
	}
}
